import { EVENT_STATUS_CONFIG } from '@/utils/events'

export const STATUS_COLORS = Object.fromEntries(
  Object.entries(EVENT_STATUS_CONFIG).map(([key, val]) => [key, val.color]),
)

export const STATUS_PALETTES = Object.fromEntries(
  Object.entries(EVENT_STATUS_CONFIG).map(([key, val]) => [key, val.colorPalette]),
)

export const DEFAULT_EVENT_COLOR = '#718096'
export const HOLIDAY_COLOR = '#F58220'
export const REMINDER_COLOR = '#6A2C91'
export const REMINDER_COLOR_PALETTE = 'primary'
